module.exports = __webpack_public_path__ + "static/media/3.0f20fe92.jpg";